(function ($) {
	var $buttons = {};

	function closeAccordionItem(button) {
		$('.accordion').foundation('up', button.parent());
	}

	function updateProgressbar() {

		var steps = $('[data-step]').length,
			steps_done = $('[data-step="true"]').length,
			percent_done = (steps_done / steps) * 100;
		percent_done = parseFloat(percent_done.toFixed(1));

		$('[data-progress]').attr('aria-valuenow', percent_done);
		$('[data-progress]').attr('aria-valuetext', percent_done + '%');
		$('[data-valuetext]').html(percent_done);
		$('[data-progress-meter]').css('width', percent_done + '%');

	}

	var handleClickOnDone = function (event) {

		var key = 'step';

		event.preventDefault();

		var step = $(this).attr('data-' + key);

		if (step === "false" || step === false) {
			$(this).attr('data-' + key, "true");
		} else {
			$(this).attr('data-' + key, "false");
		}

		updateProgressbar();

		storeSelection($buttons, key, 'button');

	};


	/* handle click on accordion-close-icon */
	$('[data-close-icon]').on('click', function (e) {
		e.preventDefault();
		closeAccordionItem($(this));
	});

	/* handle click on accordion-done-button */
	$buttons = $('[data-step]');

	$buttons.on('click.doneButton', handleClickOnDone);

	getPrecog($buttons, 'step', 'button');

	updateProgressbar();

	// Linking accordions with accordions
	function getIdFromUrl(url) {

		if (url.indexOf('#') > 0) {
			var splittedUrl = url.split('#');
			var elementId = splittedUrl[splittedUrl.length - 1];
			return elementId;
		}
		return false;
	}

	function openAccordion(element) {
		if (element === undefined) {
			return;
		}

		var parent = element.parent('.accordion-item').parents('.accordion-item').children('.accordion-title').first();
		if (parent.length !== 0) {

			parent.trigger('click');

			//check for more parents to open
			var tmp = parent.parent('.accordion-item').parents('.accordion-item').children('.accordion-title').first();
			while (tmp.length !== 0) {
				tmp.trigger('click');
				tmp = tmp.parent('.accordion-item').parents('.accordion-item').children('.accordion-title').first();
			}
			element.trigger('click');
			$(window).scrollTop(element.offset().top);
		} else {
			element.trigger('click');
			$(window).scrollTop(element.offset().top);
		}
	}

	function isAccordionOnSamePage(element) {
		var idToFind = getIdFromUrl(element.attr('href'));
		if ($('#' + idToFind).length > 0) {
			return true;
		}
		return false;
	}

	function initialScrollToAccordion(elementId) {
		var tmpId = getIdFromUrl(decodeURIComponent(window.location));
		var elementToOpen = $('#' + tmpId + '-label');
		if (elementToOpen.attr('aria-expanded') === 'false') {
			openAccordion(elementToOpen);
		}
	}

	function scrollToAccordion(element) {
		var id = getIdFromUrl(element.attr('href'));
		var targetElement = $('#' + id + '-label');
		var targetPosition = parseInt(targetElement.offset().top);

		if (targetElement.attr('aria-expanded') === 'false') {
			openAccordion(targetElement);
		} else {
			$(window).scrollTop(targetPosition);
		}
	}

	function doActionDecision(isOnSamePage, element) {
		switch (isOnSamePage) {
			case false:
				if (!element.attr('target')) {
					window.location = element.attr('href');
				}
				break;

			case true:
				scrollToAccordion(element);
				break;

			default:
				initialScrollToAccordion();
				break;
		}
	}

	function createUsability(element) {
		var idToShow = element.siblings('.accordion-content').attr('id');
        if(history.replaceState) {
            history.replaceState(null, null, '#' + idToShow);
        }
	}

	$(document).ready(function () {
		doActionDecision();
	});

	$('.accordion-content a:not(.accordion-close, .accordion-title, .button)').on('click', function (e) {
		if (!$(this).attr('target')) {
			e.preventDefault();
		}
		var isOnSamePage = isAccordionOnSamePage($(this));
		doActionDecision(isOnSamePage, $(this));
	});

	$('.accordion-title').on('click', function () {
		if ($(this).attr('aria-expanded') === 'true') {
			return;
		}
		createUsability($(this));
	});

}(jQuery));
